import { render } from "./NoiseInstruction.vue?vue&type=template&id=afb25daa&scoped=true"
import script from "./NoiseInstruction.vue?vue&type=script&lang=js"
export * from "./NoiseInstruction.vue?vue&type=script&lang=js"

import "./NoiseInstruction.vue?vue&type=style&index=0&id=afb25daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb25daa"]])

export default __exports__